export default [
  {
    path: 'modifiers',
    component: () => import('./Modifiers'),
    children: [
      {
        path: '/',
        component: () => import('./modifiers-hierarchy/ModifiersHierarchy.vue'),
        name: 'modifiersList'
      },
      {
        path: 'addCategory',
        component: () => import('./ModifierCategoryForm.vue'),
        name: 'addModifierCategory'
      },
      {
        path: ':id/edit',
        component: () => import('./ModifierCategoryForm.vue'),
        name: 'editModifierCategory'
      },
      {
        path: ':categoryId/item/add',
        component: () => import('./ModifierItemForm.vue'),
        name: 'addModifierItem'
      },
      {
        path: 'items/:id',
        component: () => import('./ModifierItemForm.vue'),
        name: 'editModifierItem'
      }
    ]
  }
]
